
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Parse from '../parseConfig';

// Route guard that only allows signed-in users with fraemohsAssociate = 1
const RequireFraemohsRoute = ({ component: Component, ...rest }) => {

  const currentUser = Parse.User.current();
  const location = useLocation();

  if (!currentUser) {
    const redirectTo = `${location.pathname}${location.search}`;
    sessionStorage.setItem('redirectTo', redirectTo);
    return <Navigate to="/" replace />;
  }

  if (currentUser.get('fraemohsAssociate') !== 1) {
    return <Navigate to="/" replace />;
  }

  return <Component {...rest} />;
};

export default RequireFraemohsRoute;
